module.exports = __webpack_public_path__ + "static/OpenSource@2x-64bc184042b1e1ac4b76cf37225e4bb1.jpg";